

function TrackList({ counter, data, generalcounter }: any) {

    return (

        <li className="nav-item">
            <a className={"nav-link " + (generalcounter == 1 ? "active" : "")} id={`cf-tab${counter}`} data-toggle="tab" href={`#confy${counter}`} role="tab" aria-controls={`confy${counter}`} >{data}</a>
        </li>
    );
}

function getSocialIcons(socialMedia: any) {
    if (!socialMedia) {
        return (<></>);
    }
    return socialMedia.map((smedia: any) => {
        return (
            <>
                { smedia.media == "facebook" && <a href={smedia.profileurl} title=""><i className="fa fa-facebook"></i></a>}
                {smedia.media == "twitter" && <a href={smedia.profileurl} title=""><i className="fa fa-twitter"></i></a>}
                {smedia.media == "linkedin" && <a href={smedia.profileurl} title=""><i className="fa fa-linkedin"></i></a>}
                {smedia.media == "instagram" && <a href={smedia.profileurl} title=""><i className="fa fa-instagram"></i></a>}
            </>
        );
    });
}

function sortSpeakersByOrder(speakers :  any) {
    return Object.keys(speakers).slice().sort((a : any, b : any) => {
        return Number(speakers[a].order) - Number(speakers[b].order);
    });
}
function Program({ counter, data }: any) {

    let speakerNames: any = [];
    const sortedSpeakers = data.speakers ? sortSpeakersByOrder(data.speakers) : [];

    sortedSpeakers.forEach(key => {
        let speakerObj = data.speakers[key];
        speakerNames.push(
            <div className="us-details">
                <h3><i className="fa fa-microphone"></i> {speakerObj.speakername}  <small>/  {getSocialIcons(speakerObj.socialmedia)} &nbsp;</small></h3>
            </div>
        );
    });

    return (
        <><style>
    {`.blog-detail-content {
            font-size: 18px;
            line-height: 1.8;
            color: #ffffff;
            word-wrap: break-word;
            overflow-wrap: break-word;
            word-break: break-word;
            overflow-wrap: anywhere;
            hyphens: auto;
            box-sizing: border-box;
            max-width: 100%;
            width: 100%;
          }
          
          .blog-detail-content p {
            margin-bottom: 20px;
            display: block;
            margin-top: 0;
            margin-bottom: 20px;
          }
          
          .blog-detail-content h2,
          .blog-detail-content h3,
          .blog-detail-content h4 {
            margin: 30px 0 15px 0;
            color: #ffffff;
          }
          
          .blog-detail-content ul,
          .blog-detail-content ol {
            margin: 15px 0 15px 20px;
          }
          
          .blog-detail-content code {
            background: #f8f9fa;
            padding: 2px 6px;
            border-radius: 4px;
            font-family: 'Courier New', monospace;
            font-size: 14px;
            word-wrap: normal;
            overflow-wrap: normal;
            word-break: normal;
            hyphens: none;
          }
          
          .blog-detail-content pre {
            background: #f8f9fa;
            padding: 20px;
            border-radius: 8px;
            overflow-x: auto;
            margin: 20px 0;
            font-size: 14px;
            word-wrap: normal;
            overflow-wrap: normal;
            word-break: normal;
            hyphens: none;
          }
          
          .blog-detail-content p strong {
           font-weight: 600;
          }
          /* Improve image responsiveness */
          .blog-detail-content img {
            max-width: 100%;
            height: auto;
            display: block;
            margin: 20px 0;
            border-radius: 8px;
            clear: both;
            float: none;
          }
          
          /* Better list styling for mobile */
          .blog-detail-content ul li,
          .blog-detail-content ol li {
            margin-bottom: 8px;
          }
          
    `}
    </style>


        <li>
            <div className="cmpt-details" >
                <div className="cmp-info">
                    <div className="cmp-head">
                        <span><i className="fa fa-clock-o"></i>{data.time}</span>
                        <h3>{data.name}</h3>
                    </div>
                    <p className="pb-5 blog-detail-content" style={{ color:'black !important'}} dangerouslySetInnerHTML={{__html: data.description || data.topic || ''}}></p>
                    <div className="cpm-speakers-bottom" >
                        {speakerNames}
                    </div>
                </div> {/* <!--cmp-info end--> */}
            </div> {/* <!--cmpt-details end--> */}
        </li>


</>

    );
}


function TabData({ counter, parentToChild, generalcounter }: any) {
    let programList: any[] = [];
    if (parentToChild.sessionsOrder) {
        parentToChild.sessionsOrder.forEach((sessionId, idx) => {
            let session = parentToChild.sessions[sessionId];
            programList.push(
                <Program key={`pg${idx}${counter}`} data={session} counter={counter} />
            );
        });
    }
    return (
        <div className={"tab-pane fade  " + (generalcounter == 1 ? " show active" : "")} id={`confy${counter}`} role="tabpanel" aria-labelledby={`cf-tab${counter}`}>
            <div className="confy-cmpt-details">
                <ul>
                    {programList}
                </ul>
            </div> {/* <!--confy-cmpt-details end--> */}
        </div>);
}

function ScheduleTab({ parentToChild, tabidcounter, generalcounter }: any) {
    // parentToChild now contains an array of tracks for this day
    const tablist: any[] = [];
    const TabDatalist: any[] = [];

    if (parentToChild && Array.isArray(parentToChild)) {
        parentToChild.forEach((track, index) => {
            let trackName = track.name;
            let lableCounter = "st" + tabidcounter + (index + 1);
            tablist.push(
                <TrackList key={lableCounter} data={trackName} counter={lableCounter} generalcounter={index + 1} />
            );
            TabDatalist.push(<TabData key={`td${lableCounter}`} parentToChild={track} counter={lableCounter} generalcounter={index + 1} />
            );
        });
    }

    return (
        <div className={"tab-pane fade  " + (generalcounter == 1 ? " show active " : "")} id={`confery${tabidcounter}`} role="tabpanel" aria-labelledby={`confery-tab${tabidcounter}`}>
            <ul className="nav nav-tabs" id={`myTab${tabidcounter}`} role="tablist">
                {tablist}
            </ul>
            <div className="tab-content" id="myTabContent2">
                {TabDatalist}
            </div>
        </div>
    );
}
export { ScheduleTab }
